export const merge = (...objects) => objects.reduce((acc, obj) => ({ ...acc, ...obj }), {});
